import { useLocalObservable } from 'mobx-react-lite';
import StoreAction from '@store/StoreAction';
import { runInAction } from 'mobx';
import { getQryRepaymentDetails, cancelRepayment } from '@api';

const initialState = {
    startDate: new Date(),
    endDate: new Date(),
    payoffDetails: [],
};

const api = {
    qryRepaymentDetails: getQryRepaymentDetails,
};
const PayoffDetailStore = () =>
    useLocalObservable(() => ({
        /* observables */
        ...initialState,
        ...StoreAction(initialState),
        ...api,
        async getPayoffDetails(defaultValue, startDate, endDate) {
            const postData = {
                queryType: defaultValue,
                startDate: startDate,
                endDate: endDate,
            };
            const res = await this.qryRepaymentDetails(postData);
            const payoffDetails = res.data.items;
            this.assignData({ payoffDetails });
        },

        async cancelRepayment(applicationNumber) {
            const postData = {
                bhno: '5850',
                applicationNumber: applicationNumber,
            };
            const res = await cancelRepayment(postData);
            console.log(res);
            const code = parseInt(res.data.code);
            console.log(code);
        },
    })); // 3

export default PayoffDetailStore; // 2
